import { Component, OnInit } from '@angular/core';
import { DataSharedService } from '../services/data-shared.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  constructor(public dataSharedService: DataSharedService) { }

  ngOnInit(): void {
  }
}
